import React from 'react';
import PropTypes from 'prop-types';
import ArchiveOutlined from '@mui/icons-material/ArchiveOutlined';
import History from '@mui/icons-material/History';

import i18n from 'i18next';
import { useModals } from 'core/notifications';

import { Button } from 'uikit/buttons';
import { Loading } from 'uikit/loaders';

const ICONS = Object.freeze({
  archive: <ArchiveOutlined />,
  restore: <History />,
});

const VersioningModalButton = ({
  isPublished = false,
  isVersioning = false,
  versionContent = () => {},
}) => {
  const { addModal } = useModals();

  if (isVersioning) return <Loading />;

  const key = isPublished ? 'archive' : 'restore';

  const handleClick = async () => {
    const contentKey = `${key}-content`;

    const { type } = await addModal({
      actions: [
        { action: 'cancel', text: i18n.t('cancel'), variant: 'ghost' },
        { action: 'submit', color: 'brand', text: i18n.t(contentKey) },
      ],
      body: i18n.t(`${contentKey}-body`),
      hasCloseButton: true,
      title: i18n.t(contentKey),
    });

    if (type === 'submit') {
      versionContent();
    }
  };

  return <Button color="brand" icon={ICONS[key]} onClick={handleClick} text={i18n.t(key)} />;
};

VersioningModalButton.propTypes = {
  isPublished: PropTypes.bool,
  isVersioning: PropTypes.bool,
  versionContent: PropTypes.func,
};

export default React.memo(VersioningModalButton);
